import React, { useState, useCallback, useMemo } from 'react';
import { Link } from 'react-router-dom';
import MarketList from '../components/MarketList';
import FeaturedMarketCard from '../components/FeaturedMarketCard';
import { useMarketContext } from '../contexts/MarketContext';
import swapIcon from '../assets/swap.png';
import icon1 from '../assets/weirdly-icon-1.png';
import cancelIcon from '../assets/cancel.svg';
import searchIcon from '../assets/search-icon.svg';
import reorderIcon from '../assets/reorder-icon.svg';
import refreshIcon from '../assets/refresh-icon.svg';
import checkSquare from '../assets/check-square.svg';
import { searchTokens, fetchMarkets, fetchSortedMarkets } from "../services/api";

const Home: React.FC = () => {
  const { loading, error, filter, searching, setFilter, setMarkets, setSearching } = useMarketContext();
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSearching(true)

    searchTokens(searchTerm)
      .then((results) => {
        if (results) {
          setMarkets(results);
        }
        setSearchTerm("")
      })
  }, [searchTerm, setMarkets, setSearching]);

  const handleRefresh = useCallback(() => {
    setSearchTerm("");
    fetchMarkets(filter)
      .then(results => {
        if (results) {
          setMarkets(results);
          setSearching(false);
        }
    });
  }, [filter, setMarkets, setSearching]);

  const handleSortedMarkets = useCallback(() => {
    setSearchTerm("");
    fetchSortedMarkets("old-new")
      .then(results => {
        if (results) {
          setMarkets(results);
          setSearching(false);
        }
    });
  }, [setMarkets, setSearching]);

  const handleFilterChange = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
    setFilter(e.target.value as any);
  }, [setFilter]);

  const filterOptions = useMemo(() => (
    <select
      value={filter}
      onChange={handleFilterChange}
      className="filter-select"
    >
      <option value="new">Launched Time</option>
      <option value="claimed">Claimed</option>
      <option value="swap">Listed on G7 Swap</option>
      <option value="top">Top</option>
      <option value="trending">Trending</option>
    </select>
  ), [filter, handleFilterChange]);

  const renderSearchButton = () => {
    if (searching) {
      return (
        <button onClick={handleRefresh} className="search-button" title="Remove Search">
          <img src={cancelIcon} alt="Search" />
        </button>
      );
    } else {
      return (
        <button type="submit" className="search-button" title="Search">
          <img src={searchIcon} alt="Search" />
        </button>
      );
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="home">
      <section className="hero">
        <div className="hero-content">
          <h1 className="hero-title">Weirdly fuN</h1>
          <p className="hero-description">
            The first Meme Launcher targeting new game releases.<br />
            Speculate on your favorite game titles and support game developers at the same time! - <Link to="/how-it-works" className="how-it-works">How it works?</Link>
          </p>
          <Link to="/claim" className="how-it-works">
            <button className="btn-sunboost" >
              <img src={swapIcon} alt="" />
              Game Developer? - Claim your Game!
            </button>
          </Link>
        </div>
        <div className="featured-market">
          <div className="sunflare-label">
            <img src={icon1} alt="" /> Weirdly Pumped Meme Coin
          </div>
          <FeaturedMarketCard />
        </div>
      </section>
      <section className="market-search">
        <form onSubmit={handleSearch} className="search-bar">
          <input
            type="text"
            placeholder="Search by Game Name or by Token Symbol (ticker)"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {renderSearchButton()}
        </form>
        <div className="filter-options">
          {filterOptions}
          <button className="btn-listed" onClick={() => setFilter("swap")}>
            <img src={checkSquare} alt="Listed on Swap" className="swap-icon" />
            Listed on G7 Swap
          </button>
          <button className="btn-icon btn-reorder" title="Reorder" onClick={handleSortedMarkets}>
            <img src={reorderIcon} alt="Reorder" />
          </button>
          <button className="btn-icon btn-refresh" title="Refresh" onClick={handleRefresh}>
            <img src={refreshIcon} alt="Refresh" />
          </button>
        </div>
      </section>
      <MarketList />
    </div>
  );
}

export default React.memo(Home);